import { jsx as _jsx } from "react/jsx-runtime";
import { ConstituentLogo } from '@modules/constituents/constituent-logo/constituent-logo';
export function CodeWithMeLogo({ className }) {
    return _jsx(ConstituentLogo, { id: "cwm", className: className });
}
